import { useTranslation } from "react-i18next";

import useVehiclesMutations from "../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { IVehicle, PartsPriority } from "../../models/Vehicle";

export default function PartsPriorityDropdown({ vehicle, classes = "" }: { vehicle: IVehicle, classes?: string }) {
  const { t } = useTranslation("vehicles");
  const { patchVehicle } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers(t("Priority Status"));

  const handleStatusUpdate = (status: string) => {
    patchVehicle.mutate(
      { vehicleId: vehicle.id, patch: { partsPriority: parseInt(status) } },
      {
        onSuccess: () => saveHandlers.onSuccess(),
        onError: () => saveHandlers.onError(),
      }
    );
  }

  return (
    <div className="w-full h-full flex items-center" onClick={(e) => e.stopPropagation()}>
      <select value={vehicle.partsPriority} className={`${classes} border border-gray-300 p-1`} onChange={(e) => handleStatusUpdate(e.target.value)}>
        {Object.values(PartsPriority).filter((ct) => isNaN(Number(ct))).map((status, i) => (
          <option key={status} value={i}>
            {t(String(status))}
          </option>
        ))}
      </select>
    </div>
  )
}
